import React from 'react';

import { Shimmer, ShimmerElementsGroup, ShimmerElementType } from '@fluentui/react/lib/Shimmer';

import { IShimmer } from '../../../../models';

const IAICommentShimmer: React.FunctionComponent<IShimmer> = ({ style }) => {
    const _handleShimmerElements = (): JSX.Element => (
        <div>
            <ShimmerElementsGroup shimmerElements={[{ type: ShimmerElementType.line, height: 125, width: '100%' }]} />
            <ShimmerElementsGroup shimmerElements={[{ type: ShimmerElementType.gap, height: 10, width: '100%' }]} />
            <ShimmerElementsGroup shimmerElements={[{ type: ShimmerElementType.line, height: 125, width: '100%' }]} />
            <ShimmerElementsGroup shimmerElements={[{ type: ShimmerElementType.gap, height: 10, width: '100%' }]} />
            <ShimmerElementsGroup shimmerElements={[{ type: ShimmerElementType.line, height: 125, width: '100%' }]} />
        </div>
    );

    return (
        <div className="iai-comment-shimmer-container" style={style}>
            <Shimmer customElementsGroup={_handleShimmerElements()} width="100%" />
        </div>
    );
}

export default IAICommentShimmer;